import { render, staticRenderFns } from "./GdprCookieSetupPopup.vue?vue&type=template&id=77ba4c04&scoped=true&"
import script from "./GdprCookieSetupPopup.vue?vue&type=script&lang=js&"
export * from "./GdprCookieSetupPopup.vue?vue&type=script&lang=js&"
import style0 from "./GdprCookieSetupPopup.vue?vue&type=style&index=0&id=77ba4c04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ba4c04",
  null
  
)

export default component.exports